import { noop } from '@sgme/fp';
import { LifeRingModal, LifeRingModalProps } from 'components/ActionBar/LifeRing/LifeRingModal/LifeRingModal';
import { AppCrashed } from 'components/shared/Blotter/AppCrashed/appCrashed';
import { type UseScreenshotOptions, useScreenshot } from 'hooks/useScreenshot';

interface LiferingModalWithScreenshotProps {
  onClose: () => void;
  isOpened: boolean;
  defaultMessage?: string;
  smartQuotes?: LifeRingModalProps['smartQuotes'];
}

export default function LiferingModalWithScreenshot({
  onClose,
  isOpened,
  defaultMessage,
  smartQuotes,
  ...props
}: LiferingModalWithScreenshotProps & UseScreenshotOptions) {
  const screenshot = useScreenshot(props);

  return (
    <>
      <AppCrashed isDeveloperMode={window.sgmeConfiguration.isDeveloper ?? false} />
      <LifeRingModal
        smartQuotes={smartQuotes}
        isOpened={isOpened}
        onClose={onClose}
        onExited={screenshot.state === 'done' ? screenshot.reset : noop}
        takeScreenshot={screenshot.state === 'done' || screenshot.state === 'idle' ? screenshot.take : noop}
        onScreenshotUpdated={screenshot.state === 'done' ? screenshot.update : noop}
        onScreenshotReverted={screenshot.state === 'done' ? screenshot.revert : noop}
        screenshot={screenshot.state === 'done' ? screenshot.image : undefined}
        defaultMessage={defaultMessage}
      />
    </>
  );
}
